import { GlobalAxios } from "../axios/axios-config";
import { IAccessControlPacientSendsLog } from "../models/access-control-pacient-sends-log";

const ACCESS_CONTROL_SECTOR_SEND_LOG_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/AccessControlSectorSendsLog/AccessControlSectorSendsLogs";

export const getAccessControlSectorSendsLog = (
  accessControlSectorSendsIdentifier: number,
) => {
  return GlobalAxios.get<IAccessControlPacientSendsLog>(
    ACCESS_CONTROL_SECTOR_SEND_LOG_ROUTE,
    {
      params: {
        accessControlSectorSendsIdentifier,
      },
    },
  );
};
